import React, { Fragment } from "react";
import { useAuthContext } from "../../context/auth.context";
import SideMenu from "../../navigation/Sidemeu";
import Footer from "./Footer";
import Header from "./Header";
import constant, { UserRoles } from "../../helper/constant";
import { useScreenSizeContext } from "../../context/mobile-layout.context";
import { useLocation } from "react-router-dom";

const BasePageContainer = ({ children, hideFooter }) => {
  const { isLoggedIn, userInfo } = useAuthContext();
  const { isMobileScreen } = useScreenSizeContext();
  const nav = useLocation();

  const renderSideMenu = () => {
    if (
      isLoggedIn &&
      userInfo &&
      userInfo.org &&
      (userInfo.org.org_config || userInfo.org.role !== UserRoles[0].id) &&
      (!nav.pathname.includes(constant.PAGES.BUSINESS_360) &&
        !nav.pathname.includes(constant.PAGES.SUMMARY_360) &&
        !nav.pathname.includes(constant.PAGES.SUPPLIER_VIEW) &&
        !nav.pathname.includes(constant.PAGES.COMPETITOR_VIEW) &&
        !nav.pathname.includes(constant.PAGES.COMPLEMENTOR_VIEW) &&
        !nav.pathname.includes(constant.PAGES.PREDICTION_VIEW) &&
        !nav.pathname.includes(constant.PAGES.CUSTOMER_VIEW) &&
        !nav.pathname.includes(constant.PAGES.IMPART_AI.IMPART_AI) &&
        !nav.pathname.includes(constant.PAGES.IMPART_AI.IMPART_AI_DETAIL))
    )
      return <SideMenu />;
  };

  return (
    <>
      <section className="container-fluid contentWrpper px-0">
        <Header />
        {!isMobileScreen && renderSideMenu()}
        {children}
        {!hideFooter && <Footer />}
      </section>
    </>
  );
};

export default BasePageContainer;
